import {styled, keyframes} from "@core-ui/react-stitch";
import {Keyframes} from "@emotion/serialize";

export const ButtonTextAnimation: Keyframes = keyframes`
  0%   { opacity: 0; width: 0; }
  35%  { width: 0; }
  50%  { width: 100%; }
  60%  { opacity: 0 }
  100% { opacity: 1 }
`;

export const IconAnimation: Keyframes = keyframes`
  0%   { transform: scale(1.0); }
  10%  { transform: scale(1.5); }
  30%  { transform: scale(1.0); }
  40%  { transform: translate(0.9375rem, 0); }
  50%  { transform: translate(0, 0); }
`;

export const IconWrapper = styled.div`
  animation: ${IconAnimation} 2s;
  animation-iteration-count: 1;
  animation-delay: 0;
  height: 1.25rem;
  width: 1.25rem;
  align-self: center;
`;

export const AnimationWrapper = styled.div`
  display: inline-flex;
  flex-flow: row;
  justify-content: center;
`;

export const TextWrapper = styled.div`
  animation: ${ButtonTextAnimation} 2s;
  animation-iteration-count: 1;
  animation-delay: 0;
  align-self: center;
  padding-left: 0.625rem;
`;

export const SvgIcon = styled.svg`
  fill: currentColor;
  display: block;
`;
